import { styled } from '@linaria/react';
import { fonts, layout, primitives, radius, semantic, size } from '../../theme/tokens';

export const StyledTextArea = styled.textarea`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
  padding: ${layout.inputPadding};
  border: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  border-radius: ${radius('input', 'radius-md')};
  background: transparent;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
  min-height: ${primitives.size['size-2000']};

  &::placeholder {
    color: ${semantic.text.tertiary};
  }

  &:hover {
    border-color: ${semantic.border.secondary};
  }

  &:focus {
    border-width: ${size.stroke['stroke-thick']};
    border-color: ${semantic.border.selected};
  }

  &:disabled {
    color: ${semantic.text.disabled};
    cursor: not-allowed;
    border-color: ${semantic.border.default};
  }

  &:disabled::placeholder {
    color: ${semantic.text.disabled};
  }

  &[aria-invalid='true'] {
    border-width: ${size.stroke['stroke-thick']};
    border-color: ${semantic.border.danger};
  }
`;
